<div class="table-row">
  <div class="table-item">{{ opinion.debateText }}</div>
  <div class="table-item">{{ opinion.created_at | date }}</div>
  <div class="table-item">
    <span [ngClass]="voteColour"> <i class="glicon-{{ voteIcon }} font-20 middle"></i> {{ voteLabel }} </span>
  </div>
  <div class="table-item">{{ opinion.authorEmail }}</div>
</div>
